// TODO: add unit test
import { deflateSync, inflateSync } from 'fflate';

export const compress = (value: string) => {
  // Compress the data using Deflate
  const compressedData = deflateSync(new TextEncoder().encode(value), {
    level: 4,
  });

  // convert to base64 string
  return Buffer.from(compressedData).toString('base64');
};

export const decompress = (value: string) => {
  // convert value from base64 string  to Uint8Array
  const compressedData = Buffer.from(value, 'base64');

  // Decompress the data
  const decompressedData = inflateSync(compressedData);

  // convert from Uint8Array to base64 string
  return new TextDecoder().decode(decompressedData);
};
